import { Link, useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from '@/lib/auth';
import { AUTH } from '@/constants/testIds';
import { Terminal } from 'lucide-react';

export const NavBar = () => {
  const { user, logout } = useAuth();
  const nav = useNavigate();
  const loc = useLocation();

  const links = [
    { to: '/', label: 'HOME' },
    { to: '/pricing', label: 'PRICING' },
    { to: '/bulletin', label: 'BULLETIN' },
    { to: '/leaderboard', label: 'BOARD' },
    ...(user ? [
      { to: '/pro/inspect', label: 'INSPECT' },
      { to: '/pro/watchlist', label: 'WATCH' },
      { to: '/pro/signals', label: 'SIGNALS' },
      { to: '/pro/manage', label: 'MANAGE' },
      ...(user.is_admin ? [{ to: '/admin/attribution', label: 'ADMIN' }] : []),
    ] : []),
  ];

  return (
    <header className="border-b border-[#3F3F46] bg-[#09090B]/85 backdrop-blur-md fixed top-0 left-0 right-0 z-30">
      <div className="max-w-7xl mx-auto px-6 md:px-8 h-16 flex items-center justify-between">
        <Link to="/" className="flex items-center gap-2.5 group">
          <div className="w-7 h-7 border border-[#38BDF8]/40 flex items-center justify-center bg-[#18181B]">
            <Terminal className="w-3.5 h-3.5 text-[#38BDF8]" strokeWidth={2.5} />
          </div>
          <span className="text-sm tracking-[0.24em] font-bold uppercase text-white">
            Caelix <span className="text-[#38BDF8]">·</span> Intelligence
          </span>
        </Link>
        <nav className="hidden sm:flex items-center gap-6">
          {links.map((l) => {
            const active = loc.pathname === l.to || (l.to !== '/' && loc.pathname.startsWith(l.to));
            return (
              <Link
                key={l.to}
                to={l.to}
                className={`text-xs tracking-[0.22em] uppercase transition-colors ${
                  active ? 'text-[#38BDF8]' : 'text-gray-500 hover:text-white'
                }`}
              >
                {l.label}
              </Link>
            );
          })}
        </nav>
        <div className="flex items-center gap-3">
          {user ? (
            <>
              <span className="hidden md:inline text-[10px] tracking-[0.2em] uppercase text-gray-600">
                OP::{user.email.length > 18 ? `${user.email.slice(0, 15)}…` : user.email}
              </span>
              <button
                data-testid={AUTH.logoutBtn}
                onClick={() => { logout(); nav('/'); }}
                className="c-btn-secondary text-xs px-3 py-1.5"
              >
                LOGOUT
              </button>
            </>
          ) : (
            <>
              <Link to="/login" className="c-btn-secondary text-xs px-3 py-1.5">LOGIN</Link>
              <Link to="/signup" className="c-btn-primary text-xs px-3 py-1.5">SIGNUP</Link>
            </>
          )}
        </div>
      </div>
    </header>
  );
};

export default NavBar;
